import { Flex, Stack } from "PFComponents/containers";
import { ProfileAvatar } from "PFComponents/profile_avatar/profile_avatar";
import { SuspendedPill } from "PFComponents/suspended_pill";
import { getAttribute } from "PFCore/helpers/get_attribute";
import { getProfileName } from "PFCore/helpers/profile";
import { Profile } from "PFTypes";
import { Link } from "react-router";

import css from "./profile_cell.module.scss";

type IProps = {
  qaId?: string;
  profile: Profile;
  onClick?: (IProfile) => void;
};

const ProfileCell = ({ profile, qaId, onClick }: IProps) => {
  const suspendedAt = getAttribute(profile, "suspendedAt");
  const content = (
    <Stack gap="spacingSm">
      <Flex alignItems="center">
        <ProfileAvatar profile={profile} size={20} />
        <span className={css.username}>{getProfileName(profile)}</span>
      </Flex>
      {suspendedAt && <SuspendedPill suspendedAt={suspendedAt} />}
    </Stack>
  );

  if (profile?.suspendedAt) {
    return content;
  }

  if (onClick) {
    return (
      <button className={css.button} onClick={() => onClick(profile)}>
        {content}
      </button>
    );
  }

  return (
    <Link to={`/profiles/${profile.id}`} data-qa-id={qaId}>
      {content}
    </Link>
  );
};

export default ProfileCell;
